import { __assign, __spreadArray } from "tslib";
function prepareFilterValue(filterValue) {
    var value = (Array.isArray(filterValue) && filterValue.join('-')) || filterValue;
    return value + '';
}
function prepareBasicFilters(resultData, usage) {
    var tagFilter = new Array();
    var basicFilters = resultData.basicFilters || [];
    if (usage === 'filters') {
        basicFilters.forEach(function (el) { return tagFilter.push({
            filterName: el,
            filterValue: prepareFilterValue(resultData[el]) || '',
        }); });
    }
    return tagFilter;
}
function prepareAdvancedFilters(resultData, usage) {
    var tagFilter = new Array();
    var advancedFilters = (resultData === null || resultData === void 0 ? void 0 : resultData.technicalSpecificationRange) || {};
    for (var filterName in advancedFilters) {
        if (Object.prototype.hasOwnProperty.call(advancedFilters, filterName)) {
            var filterValue = advancedFilters[filterName];
            if (filterValue.visible) {
                var _a = filterValue || {}, _b = _a.value, value = _b === void 0 ? null : _b, _c = _a.displayText, filterText = _c === void 0 ? null : _c;
                if (filterText) {
                    if (usage === 'filters') {
                        tagFilter.push({
                            filterName: filterName,
                            filterValue: value ? value + '' : 'null',
                        });
                    }
                    else if (usage === 'settings') {
                        tagFilter.push({
                            calculationname: filterName.toLowerCase(),
                            currentvalue: value ? value + '' : 'null',
                        });
                    }
                }
            }
        }
    }
    return tagFilter;
}
function prepareFiltersObject(resultData, usage) {
    if (usage === void 0) { usage = 'filters'; }
    return __spreadArray(__spreadArray([], prepareBasicFilters(resultData, usage), true), prepareAdvancedFilters(resultData, usage), true);
}
;
function prepareCarObject(resultData, carData, currencyCode, isOnlyModelData) {
    if (isOnlyModelData === void 0) { isOnlyModelData = false; }
    var carInfo = {
        tmeModelId: (resultData === null || resultData === void 0 ? void 0 : resultData.modelId) || 'null',
        modelName: (resultData === null || resultData === void 0 ? void 0 : resultData.modelName) || 'null',
    };
    var productInfo = isOnlyModelData ?
        carInfo : __assign(__assign({}, carInfo), { productId: (carData === null || carData === void 0 ? void 0 : carData.id) || 'null', productName: (carData === null || carData === void 0 ? void 0 : carData.grade) || 'null', price: (carData === null || carData === void 0 ? void 0 : carData.price) || 0, currencyCode: currencyCode, gradeId: (carData === null || carData === void 0 ? void 0 : carData.gradeId) || 'null', gradeName: (carData === null || carData === void 0 ? void 0 : carData.grade) || 'null', engineId: (carData === null || carData === void 0 ? void 0 : carData.engineId) || 'null', engineName: (carData === null || carData === void 0 ? void 0 : carData.engine) || 'null', engineType: (carData === null || carData === void 0 ? void 0 : carData.engineType) || 'null', engineIsHybrid: (carData === null || carData === void 0 ? void 0 : carData.hybridIsAvailable) * 1 + '' || 'null', bodytypeId: (carData === null || carData === void 0 ? void 0 : carData.bodytypeId) || 'null', bodytypeName: (carData === null || carData === void 0 ? void 0 : carData.bodyType) || 'null', transmissionId: (carData === null || carData === void 0 ? void 0 : carData.transmissionId) || 'null', transmissionName: (carData === null || carData === void 0 ? void 0 : carData.transmission) || 'null' });
    return {
        category: 'cars',
        subCategory: 'new-cars',
        productInfo: productInfo,
    };
}
export { prepareFilterValue, prepareBasicFilters, prepareAdvancedFilters, prepareFiltersObject, prepareCarObject, };
